<template>
	<form-item class="form_radio" :label="$attrs.label">
		<div class="radio__inner">
			<van-row gutter="14" v-for="(item, index) in getOptions" :key="`row_${ index }`">
				<van-col :span="8" v-for="(val, idx) in item" :key="`col_${ idx }`">
					<van-button
						v-if="val"
						:type="modelValue === val ? 'primary' : 'default'"
						plain
						block
						@click="modelValue = val"
					>
						{{ val }}
					</van-button>
					<van-button plain block v-else class="hide"></van-button>
				</van-col>
			</van-row>
		</div>
	</form-item>
</template>

<script>
	export default {
		name: 'FormRadio',
		data: () => ({
			colNum: 3
		}),
		props: {
			value: {
				type: [String, Number, Boolean],
				default: ''
			},
			radioType: {
				type: String,
				default: ''
			},
			options: {
				type: Array,
				default: () => []
			},
			preview: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			modelValue: {
				get() {
					return this.value
				},
				set(val) {
					if (this.preview) return
					this.$emit('input', val)
				}
			},
			getOptions() {
				if (this.preview) return [this.value]
				if (this.options.length <= this.colNum) return [this.options]
				const list = this.options.reduce((val, item) => {
					if (!val.length || !(val[val.length - 1].length ^ this.colNum)) val[val.length] = [item]
					else val[val.length - 1].push(item)
					return val
				},[])

				const lastChildLen = list[list.length - 1].length
				if (lastChildLen < this.colNum) {
					list[list.length - 1] = [...list[list.length - 1], ...new Array(this.colNum - lastChildLen).fill('')]
				}
				return list
			}
		}
	};
</script>

<style scoped lang="less">
	.form_radio {
		.radio__inner {
			>div + div { margin-top: 28px; }
		}
	}
</style>
<style lang="less">
	.form_radio {
		.radio__inner {
			.van-button {
				height: 80px;
				border-radius: 10px;
				font-size: 30px;
				font-weight: normal;
				padding: 0;
				&.van-button--default {
					border-color: #F5F6F7;
					background-color: #F5F6F7;
					color: #1F2329;
				}
				&.van-button--primary {
					background-color: mix(@white, @primary, 90%);
				}
			}
		}
	}
</style>
